import { createFileRoute } from '@tanstack/react-router'
import { PasswordRecoveryPage } from '@/features/auth/components/PasswordRecoveryPage'

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: ResetPasswordRoute,
})

// eslint-disable-next-line react-refresh/only-export-components
function ResetPasswordRoute() {
  const { token } = Route.useSearch()
  return <PasswordRecoveryPage mode="reset" token={token} />
}
